import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneConfig from './submodules/clone';
import CreateConfig from './submodules/create';
import ConfigList from './submodules/list';
import EditConfig from './submodules/edit';

const GstConfigDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getGSTConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ConfigList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createGSTConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createGSTConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateGSTConfigs]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditConfig}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default GstConfigDashboard;
